
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { MarkerInfoWindowType } from "@/types/MappingTypes";
import MarkerInfoWindowDetails from "./MarkerInfoWindowDetails.vue";

@Component({
	components: {
		"marker-info-window-details": MarkerInfoWindowDetails
	}
})
export default class MarkerInfoWindow extends Vue {
	@Prop({ type: Object, required: true })
    public itemInfo: MarkerInfoWindowType;

	@Prop({ type: Boolean, default: false })
	public allowDeviceControl: boolean;
}
